import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Constants, Globals, Socket, SocketEvents } from 'utils';
import { EllipsisVIcon } from 'assets/icons';
import { RootState } from 'reducers';
import { HomeService } from "services";

const ACTION = {
  ACCESS_DATA: 1,
  PATIENT_ACCESS: 2,
	INITIALIZE: 3,
	FINISH: 4,
	EXIT: 5,
};

interface Props {
  origin: 'advertisement' | 'teleconsultation'
  consultation: any
  onCloseRoom: any
  onFinish: any
}

const RoomHeaderActions = ({ consultation, onFinish, onCloseRoom, origin }: Props) => {
	const user = useSelector((state: RootState) => state.user);
	const isDoctor = user?.level_id === Constants.LEVELS.AFFILIATE;
	const [roomId, setRoomId] = useState('');
	const [shown, setShown] = useState(false);
	const [isPatientInvited, setIsPatientInvited] = useState(false);

  const givePatientAccess = () => {
    Globals.confirm('¿Estás seguro que deseas darle acceso al paciente?', async () => {
			if (origin === 'teleconsultation') {
				Socket.emit(SocketEvents.CONSULTATION_REQUEST.ROOM.JOIN, {
					appointment_id: consultation?.id,
					user_id: consultation.client_id,
					doctor_id: consultation.affiliate_id,
					level_id: Constants.LEVELS.AFFILIATE,
					room_id: roomId,
				});
			} else {
				await HomeService.affiliate.givePatientAccess({ id: consultation.id });
			}

			setIsPatientInvited(true);
			Globals.showSuccess('Se le ha dado acceso al paciente. Por favor permanezca en la sala');
		});
  };

  const validate = async () => {
    Globals.confirm('¿Estás seguro que deseas iniciar la consulta?', () => {
			// Globals.showLoading();
			// AppointmentsService.doctor.startValidate({ id: consultation.id })
			// 	.then((validation: any) => {
			// 		if (validation?.canContinue) return initialize();

			// 		Alert.alert(
			// 			'Confirmar',
			// 			validation.message,
			// 			[
			// 				{ text: 'Cancelar', style: 'cancel' },
			// 				{ text: 'Aceptar', onPress: () => initialize() }
			// 			]
			// 		)
			// 	})
			// 	.catch(() => {
			// 		// Globals.quitLoading();
			// 		Globals.sendToast('Error', 'Ocurrió un error inesperado');
			// 	});
		});
  };

  // const initialize = async () => {
	// 	try {
	// 		const response = await fetchConsultationsService({ id: consultation.id }) as any;
	// 		console.log(response)
	// 		Globals.showSuccess('La consulta ha iniciado');

	// 	} catch (error) {
	// 		console.log(error);
	// 		Globals.showError('Ocurrió un error inesperado');
	// 	}
  // };

  const finish = async () => {
		Globals.confirm('¿Estás seguro que deseas finalizar la consulta?', async () => {
			onFinish(consultation);
			onCloseRoom();
			Globals.showSuccess('Consulta culminada con éxito.');
		});
  };

	const onClickAction = (action: number) => {
		setShown(false);

		switch (action) {
			case ACTION.PATIENT_ACCESS: givePatientAccess(); break;
			case ACTION.INITIALIZE: validate(); break;
			case ACTION.FINISH: finish(); break;
			case ACTION.EXIT: onCloseRoom(); break;

			default:
				break;
		}
	};

	useEffect(() => {
		const link = String(consultation?.video_room_url).split('/').pop();
		if (link) setRoomId(link);
	}, [consultation]);

	return (
		<div className="room-header-actions">
			<button className="room-header-actions__toggle-btn" onClick={() => setShown(!shown)}>
				<img src={EllipsisVIcon} alt="Menú" />
			</button>

			{shown && (
				<div className="room-header-actions__menu">
					{(isDoctor && !isPatientInvited) && (
						<button className="room-header-actions__item" onClick={() => onClickAction(ACTION.PATIENT_ACCESS)}>
							<span>Dar acceso al paciente</span>
						</button>
					)}
					<button className="room-header-actions__item" onClick={() => onClickAction(ACTION.EXIT)}>
						<span>Salir de la sala</span>
					</button>
				</div>
			)}
		</div>
	);
};

export default RoomHeaderActions;
